export var TradevestCorporateActionEventType;
(function (TradevestCorporateActionEventType) {
    TradevestCorporateActionEventType["DVCA"] = "DVCA";
    TradevestCorporateActionEventType["INTR"] = "INTR";
    TradevestCorporateActionEventType["REDM"] = "REDM";
    TradevestCorporateActionEventType["BONU"] = "BONU";
    TradevestCorporateActionEventType["SPLF"] = "SPLF";
    TradevestCorporateActionEventType["TEND"] = "TEND";
    TradevestCorporateActionEventType["CHDV"] = "CHDV";
    TradevestCorporateActionEventType["EXRI"] = "EXRI";
    TradevestCorporateActionEventType["MEET"] = "MEET";
    TradevestCorporateActionEventType["DVOP"] = "DVOP";
    TradevestCorporateActionEventType["LIQU"] = "LIQU";
    TradevestCorporateActionEventType["DVSE"] = "DVSE";
})(TradevestCorporateActionEventType || (TradevestCorporateActionEventType = {}));
export const TRADEVEST_ELECTIVE_CORPORATE_ACTIONS = [
    TradevestCorporateActionEventType.TEND,
    TradevestCorporateActionEventType.DVOP,
    TradevestCorporateActionEventType.EXRI,
    TradevestCorporateActionEventType.MEET,
];
export function isElectiveCorporateAction(eventType) {
    return TRADEVEST_ELECTIVE_CORPORATE_ACTIONS.includes(eventType);
}
export var TradevestCorporateActionStatus;
(function (TradevestCorporateActionStatus) {
    TradevestCorporateActionStatus["ANNOUNCED"] = "ANNOUNCED";
    TradevestCorporateActionStatus["PENDING"] = "PENDING";
    TradevestCorporateActionStatus["SETTLED"] = "SETTLED";
    TradevestCorporateActionStatus["REJECTED"] = "REJECTED";
})(TradevestCorporateActionStatus || (TradevestCorporateActionStatus = {}));
export var TradevestCorporateActionNotificationType;
(function (TradevestCorporateActionNotificationType) {
    TradevestCorporateActionNotificationType["CREATED"] = "CREATED";
    TradevestCorporateActionNotificationType["UPDATED"] = "UPDATED";
    TradevestCorporateActionNotificationType["VALIDATION_ERROR"] = "VALIDATION_ERROR";
})(TradevestCorporateActionNotificationType || (TradevestCorporateActionNotificationType = {}));
export var TradevestCorporateActionOption;
(function (TradevestCorporateActionOption) {
    TradevestCorporateActionOption["NONE"] = "NONE";
    TradevestCorporateActionOption["CASH"] = "CASH";
    TradevestCorporateActionOption["STOCK"] = "STOCK";
})(TradevestCorporateActionOption || (TradevestCorporateActionOption = {}));
export var TradevestCorporateActionErrorType;
(function (TradevestCorporateActionErrorType) {
    TradevestCorporateActionErrorType["CUSTOMER_PRODUCT_NOT_SUBJECTABLE_TO_CORPORATE_ACTION"] = "CUSTOMER_PRODUCT_NOT_SUBJECTABLE_TO_CORPORATE_ACTION";
    TradevestCorporateActionErrorType["RESPONSE_DEADLINE_EXCEEDED"] = "RESPONSE_DEADLINE_EXCEEDED";
    TradevestCorporateActionErrorType["OPTION_MISSMATCH_WITH_ANNOUNCED_OPTIONS"] = "OPTION_MISSMATCH_WITH_ANNOUNCED_OPTIONS";
    TradevestCorporateActionErrorType["INSUFFICIENT_POSITION_TO_COVER_TENDERED_QUANTITY"] = "INSUFFICIENT_POSITION_TO_COVER_TENDERED_QUANTITY";
    TradevestCorporateActionErrorType["TENDER_CANNOT_BE_SUBMITTED"] = "TENDER_CANNOT_BE_SUBMITTED";
    TradevestCorporateActionErrorType["MAXIMUM_QUANTITY_SHARES_EXCEEDED"] = "MAXIMUM_QUANTITY_SHARES_EXCEEDED";
    TradevestCorporateActionErrorType["MAXIMUM_CASH_AMOUNT_EXCEEDED"] = "MAXIMUM_CASH_AMOUNT_EXCEEDED";
})(TradevestCorporateActionErrorType || (TradevestCorporateActionErrorType = {}));
export var CorporateActionSource;
(function (CorporateActionSource) {
    CorporateActionSource["WEBHOOK"] = "WEBHOOK";
    CorporateActionSource["RECONCILIATION"] = "RECONCILIATION";
})(CorporateActionSource || (CorporateActionSource = {}));
//# sourceMappingURL=tradevest-corporate-actions.types.js.map